import React from 'react';
import PropTypes from 'prop-types';
import {
    TableCell, TableRow, Button,
    useTheme, Typography
} from '@material-ui/core';
import {withRouter} from "react-router-dom";
import { themeTypeToBool } from '../../../utils/helpers';
import useStyles from "./styles";
import { convertFromEpoch } from "../../../utils/helpers";
import { Spring } from 'react-spring/renderprops';
import t from "../../../languages/pl";

export const getRowBackground = (alarmType = "", themeType) => {
    switch (alarmType.toLowerCase()) {
        case "offline":
            return themeTypeToBool(themeType) ? "#BCE1FF" : "#534D94";
        case "brak akumulatora":
            return themeTypeToBool(themeType) ? "rgba(255, 128, 0, 0.25)" : "#CC8C4D";
        case "alarm":
            return themeTypeToBool(themeType) ? "rgba(255, 0, 0, 0.25)" : "#B74747";
        case "poza rejonem":
            return themeTypeToBool(themeType) ? "rgba(110, 254, 0, 0.25)" : "#57783B";
        case "spuszczenie paliwa":
            return themeTypeToBool(themeType) ? "rgba(110, 254, 0, 0.25)" : "#57783B";
        default:
            return "#fff";
    }
};

const animationConfig = { mass: 5, tension: 2000, friction: 200, duration: 2000 };

function AlertRow(props) {
    const classes = useStyles();
    const theme = useTheme();
    const { car, event = "", date = 0 } = props;

    const handleDetailsClick = () => {
        //console.log( convertFromEpoch(date))
        props.history.push({
            pathname: "/map",
            search: `?id=${car}&date=${date}`
        });
    };

    return (
            <Spring
                from={{ opacity: 0, marginTop: -1000 }}
                to={{ opacity: 1, marginTop: 0}}
                delay='500'
                config={animationConfig}>
                {
                    props => <TableRow
                                className={classes.tableRow}
                                style={{...props, background: getRowBackground(event, theme.palette.type)}}
                                >
                        <TableCell className={classes.tableCell}>
                            <Typography variant="body1">{car}</Typography>
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                            <Typography variant="body1">{convertFromEpoch(date)}</Typography>
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                            <Typography variant="body1">{event.toUpperCase()}</Typography>
                        </TableCell>
                        <TableCell className={classes.tableCell} align="center">
                            <Button className={classes.button} variant="outlined" onClick={handleDetailsClick}>
                                <Typography variant="button">
                                    {t.details}
                                </Typography>
                            </Button>
                        </TableCell>
                    </TableRow>
                }
            </Spring>
    );
}

export default withRouter(AlertRow);

AlertRow.propTypes = {
    car: PropTypes.string,
    event: PropTypes.string,
    date: PropTypes.number,
    //router
    history: PropTypes.object
};